<example-shell
  exampleId="dark" [title]="title" [summary]="summary" [dataSnippet]="dataSnippet" [events]="events" (clear)="clearEvents()">
  <stackline-data-table
    title="Dark theme"
    theme="dark"
    [columns]="revenueColumns"
    [data]="revenue"
    [pagination]="true"
    [paginationPerPage]="5"
    [fixedHeader]="true"
    fixedHeaderScrollHeight="320px"
    [striped]="true"
    [highlightOnHover]="true">
  </stackline-data-table>
</example-shell>
